export default "__VITE_ASSET__CkZg1nLA__"